import { render, staticRenderFns } from "./CvList.vue?vue&type=template&id=5f780cf8"
import script from "./CvList.vue?vue&type=script&lang=js"
export * from "./CvList.vue?vue&type=script&lang=js"
import style0 from "./CvList.vue?vue&type=style&index=0&id=5f780cf8&prod&lang=scss"
import style1 from "./CvList.vue?vue&type=style&index=1&id=5f780cf8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports